module.exports = __webpack_public_path__ + "static/media/innocent-color-pallete.66691733.png";